// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"QQ-z","inlineTitle":"RQ-z","sponsoredAdsWrapper":"SQ-z","marketplaceRecosWrapper":"TQ-z"};